// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1d6Sb","buttons":"Footer_buttons__1m9QI"};